var _mask, _path, _path2, _path3, _circle, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 205,
    viewBox: "0 0 312 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3063_1130",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1.5,
    width: 310,
    height: 203,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: 1.5,
    width: 310,
    height: 203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 197.818C5.39995 175.473 4.27795 151.944 8.52549 129.091C12.773 106.237 22.2739 84.6832 36.2782 66.1302C50.2826 47.5773 68.4072 32.533 89.2216 22.1845C110.036 11.8361 132.971 6.46669 156.216 6.50016C179.461 6.53362 202.38 11.969 223.165 22.3773C243.949 32.7857 262.031 47.8821 275.981 66.4753C289.932 85.0685 299.371 106.65 303.553 129.515C307.735 152.381 306.545 175.906 300.077 198.233L251.859 184.266C256.162 169.411 256.953 153.76 254.171 138.546C251.389 123.333 245.109 108.975 235.827 96.6041C226.545 84.2335 214.515 74.1894 200.687 67.2645C186.858 60.3395 171.609 56.7232 156.144 56.7009C140.678 56.6787 125.419 60.2511 111.571 67.1362C97.722 74.0213 85.6632 84.0307 76.3458 96.3745C67.0283 108.718 60.7071 123.059 57.8811 138.264C55.0551 153.469 55.8016 169.123 60.0617 183.99L11.8029 197.818Z",
    stroke: "#F6F6F6",
    strokeWidth: 10,
    mask: "url(#path-1-outside-1_3063_1130)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8107 197.846C4.4062 172.023 4.07219 144.686 10.8436 118.69C17.6151 92.6937 31.2434 68.9932 50.3049 50.0644L85.6781 85.6854C72.996 98.2793 63.9286 114.048 59.4234 131.344C54.9182 148.639 55.1404 166.828 60.0669 184.008L11.8107 197.846Z",
    fill: "#2DB217"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 160.5,
    r: 23,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.456 165.73C167.705 173.988 158.908 178.493 150.809 175.795C142.708 173.097 8.97561 111.95 8.97561 111.95C8.97561 111.95 152.666 143.196 160.768 145.894C168.867 148.592 173.205 157.476 170.456 165.73Z",
    fill: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "matrix(0.31598 -0.948766 -0.948766 -0.31598 160.617 170.901)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLr);
export default __webpack_public_path__ + "static/media/img_lr.76395c9e013e65b9a90671b869003447.svg";
export { ForwardRef as ReactComponent };